import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicFieldDropdown, BaasicButton, BaasicDropdown, BaasicModal, BasicInput, BaasicDraggableModal } from "core/components";
import { observer } from "mobx-react";
import { FacilityOrderTemplateItemNewFlowNoteModal } from "application/facility-order-new-flow/components";
import { NikoPatientTemplateItemCalculationModal } from "application/niko-patient/components";

const NikoTemplateCreateTemplate = function ({ nikoTemplateCreateViewStore, disabled }) {
    const {
        form,
        subCategoryStore,
        patientTemplateItems,
        nikoPatientTemplateItemCalculationModal,
        facilityOrderTemplateItemNewFlowNoteModal,
        disabledTable,
        patientTemplateTrachItems,
    } = nikoTemplateCreateViewStore;

    return (
        <React.Fragment>
            <div className="row">
                <div className="form__group col col-med-3">
                    <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} disabled={disabled || disabledTable} />
                </div>
                <div className="form__group col col-med-9">
                    <BasicInput field={form.$('note')} disabled={disabled || disabledTable} />
                </div>
            </div>
            <div className="table--tertiary__wrapper u-mar--bottom--sml">
                <TemplateItemsTable nikoTemplateCreateViewStore={nikoTemplateCreateViewStore} patientTemplateItems={patientTemplateItems} disabled={disabled} />
            </div>
            {patientTemplateTrachItems.length > 0 &&
                <div className="table--tertiary__wrapper">
                    <TemplateItemsTable nikoTemplateCreateViewStore={nikoTemplateCreateViewStore} patientTemplateItems={patientTemplateTrachItems} disabled={disabled} />
                </div>
            }
            <BaasicDraggableModal modalParams={nikoPatientTemplateItemCalculationModal} className="modal__content modal--lrg">
                <NikoPatientTemplateItemCalculationModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderTemplateItemNewFlowNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateItemNewFlowNoteModal />
            </BaasicModal>
        </React.Fragment>
    );
};

const TemplateItemsTable = observer(({ nikoTemplateCreateViewStore, patientTemplateItems, disabled }) => {
    const {
        patientTemplateTrachItems,
        productStore,
        itemCategory,
        saveItem,
        editItem,
        deleteItem,
        openNikoPatientTemplateItemCalculationModal,
        disabledTable,
    } = nikoTemplateCreateViewStore;

    const productDropdownItemRender = (li, itemProps) => {
        const itemName = itemProps && itemProps.dataItem.description;
        const isPreferredIcon = itemProps && itemProps.dataItem.isPreferred && itemCategory === "ostomy" ?
            <i className="u-icon u-icon--xsml u-icon--star-outlined u-mar--right--tny"></i> : null;
        const isBackorderedIcon = itemProps && itemProps.dataItem.backordered ? <i className="u-icon u-icon--sml u-icon--backordered u-mar--left--tny"></i> : null;
        const nonBillableIcon = itemProps && !itemProps.dataItem.billableToMedicare ? <i className="u-icon u-icon--sml u-icon--non-billable u-mar--left--tny"></i> : null;
        const itemChildren = (
            <span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
                <span style={{ flex: "1" }}> {li.props.children} </span>
                <span style={{ fontSize: "12px" }}> {isPreferredIcon} {itemName} {nonBillableIcon} {isBackorderedIcon}</span>
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    const isEnteral = itemCategory === "enteral" && patientTemplateItems !== patientTemplateTrachItems;

    return (
        <table className="table table--tertiary">
            <colgroup>
                <col width="225" />
                <col width="200" />
                <col width="90" />
                <col width="70" />
                <col width="200" />
                <col width="70" />
            </colgroup>
            <thead>
                <tr>
                    <th>Item Id</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>QTY</th>
                    <th>NOTE</th>
                    <th className="type--right">Actions</th>
                </tr>
            </thead>
            <tbody>
                {patientTemplateItems.map((item, index) => {
                    let isFormula = (item && item.product && item.product.itemType && (item.product.itemType.abrv === 'bottle' || item.product.itemType.abrv === 'can')) || (item.product && item.product.procedureCode_ && item.product.procedureCode_.abrv === "B4155");
                    return (
                        <tr key={index}>
                            <td>
                                {
                                    item.product ? item.product.itemId :
                                        <BaasicDropdown
                                            placeholder="Select an ID..."
                                            store={productStore}
                                            value={item.product}
                                            itemRender={productDropdownItemRender}
                                            onChange={(e) => { saveItem(patientTemplateItems, index, e.target.value); }}
                                            disabled={disabled || disabledTable}
                                        />
                                }
                            </td>
                            <td className="is-flex">
                                {item.product && item.product.description} <span className="table__icons-wrapper"> {item.product && !item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable u-mar--left--tny"></i>} {(item.isBackordered != null ? item.isBackordered : item.product && item.product.backordered) && <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>}</span>
                            </td>
                            <td>
                                {item.product && item.product.unitOfMeasure ? item.product.unitOfMeasure.name : (item.product && item.product.uoM)}
                            </td>
                            <td className="table-col-input text-align-left">
                                <input
                                    className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                    onClick={(e) => e.target.select()}
                                    onChange={(e) => {
                                        editItem(patientTemplateItems, index, e.target.value, 'quantity')
                                    }}
                                    value={item.quantity || item.quantity === 0 ? item.quantity : undefined}
                                    type="number"
                                    min="0"
                                    disabled={disabled || disabledTable}
                                />
                            </td>
                            <td>
                                {isEnteral && isFormula ?
                                    <input
                                        className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                        onClick={() => openNikoPatientTemplateItemCalculationModal(patientTemplateItems, index)}
                                        value={item.note}
                                        readOnly={true}
                                    /> :
                                    <input
                                        className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                        onClick={(e) => e.target.select()}
                                        onChange={(e) => { item.note = e.target.value }}
                                        value={item.note}
                                        disabled={disabled || disabledTable}
                                    />
                                }
                            </td>
                            <td className="type--right">
                                <div className="table__icons">
                                    {
                                        item.product &&
                                        <BaasicButton
                                            className="btn btn--icon"
                                            icon="u-icon u-icon--delete--primary u-icon--sml"
                                            label="Delete"
                                            onlyIcon={true}
                                            onClick={() => deleteItem(patientTemplateItems, index)}
                                            disabled={disabled || disabledTable}
                                        ></BaasicButton>
                                    }
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
});

TemplateItemsTable.propTypes = {
    nikoTemplateCreateViewStore: PropTypes.object.isRequired,
    patientTemplateItems: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
};

NikoTemplateCreateTemplate.propTypes = {
    nikoTemplateCreateViewStore: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
};

export default defaultTemplate(NikoTemplateCreateTemplate);
